import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ComingSoonComponent} from './coming-soon.component';
import {ComingSoonRoutingModule} from 'src/app/main/coming-soon/coming-soon-routing.module';
import {SharedModule} from 'src/app/shared/shared.module';

@NgModule({
  declarations: [
    ComingSoonComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,

    ComingSoonRoutingModule
  ]
})
export class ComingSoonModule {
}
